import styles from "./BackButton.module.css";

type Props = {
  onClick: () => void;
};

export function BackButton({ onClick }: Props) {
  return (
    <button className={styles.buttonNoStyle} onClick={onClick}>
      <span>Back to menu</span>
    </button>
  );
}
